<n-slide-window *ngIf="pageReady"
    [(visible)]="windowVisible"
    [loading]="loading"
    [width]="SWITCH.IS_SIMPLE_MODE ? '4.16rem' : '7.5rem'"
    (onHide)="close()">
    <n-header>
        <h1>{{title}}</h1>
        <n-help-link [key]="helpKey" *ngIf = "!SWITCH.IS_SIMPLE_MODE"></n-help-link>
    </n-header>
    <form [formGroup]="vm"
        [errorMessage]="errorMessage"
        [simpleMode]="SWITCH.IS_SIMPLE_MODE"
        [ngClass]="{ 'form-width-simple': SWITCH.IS_SIMPLE_MODE, 'common-form': !SWITCH.IS_SIMPLE_MODE }">
        <!-- 文件扩展名 -->
        <n-form-item [label]="i18n.fileNameExtension"
            required="true">
            <n-multi-input id="add-extension-filtering-rules"
                formControlName="rules"
                [nTooltip]="i18n.extensionNameTips"
                [seperator]="[',']"
                [nTooltipTrigger]="'focus'"
                [nTooltipPlacement]="'left'">
            </n-multi-input>
        </n-form-item>
        <!-- 规则类型 -->
        <n-form-item [label]="i18n.ruleType"
            [helpContent]="i18n.ruleTypeTip"
            required="true">
            <n-select id="add-extension-filtering-rule-type"
                [options]="ruleTypeOpt"
                formControlName="ruleType">
            </n-select>
        </n-form-item>
        <!-- 操作类型 -->
        <n-form-item [label]="i18n.operationType"
            [helpContent]="i18n.operationTypeTip"
            required="true">
            <n-checkbox-group
                id="add-extension-filtering-operation-type"
                formControlName="operations">
                <n-checkbox
                    *ngFor="let item of operations; let i = index"
                    [ngClass]="SWITCH.IS_SIMPLE_MODE ? 'operations-checkbox-col-3' : 'operations-checkbox-col-' + i % 3"
                    [label]="item.label"
                    [value]="item.value">
                </n-checkbox>
            </n-checkbox-group>
        </n-form-item>
    </form>

    <n-footer>
        <button id="add-extension-filtering-ok-btn"
            nButton
            theme="primary"
            [label]="i18n.okBtn"
            (click)="onOk()">
        </button>
        <button id="add-extension-filtering-cancel-btn"
            nButton
            [label]="i18n.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
